<template>
<div>
    <div class="mid_scroll_content accoutProfileMid-height">
		<loader v-if="pageLoader"></loader>
        <section class="depoist_fund border-0">
            <div class="profileDetalied custom-max-width">
                <alert-notification v-if="notification_msg != ''"/>
                <div class="row mx-0 accountInnerSmallInfo">
                    <div class="col-12">
                        <div class="colooredScheme">
                            <div class="d-flex align-items-center justify-content-between">
                                <div class="leftPOrtName d-flex align-items-center">
                                    <div class="profileName">
                                        <!-- <p>{{(profileInfo.firstname)?profileInfo.firstname.charAt(0):profileInfo.email.charAt(0)}}</p> -->
                                        <p v-if="'firstname' in profileInfo && profileInfo.firstname">{{profileInfo.firstname.charAt(0)}}{{(profileInfo.lastname)?profileInfo.lastname.charAt(0):''}}</p>
                                        <p v-else-if="'email' in profileInfo && profileInfo.email != '' && profileInfo.email != null">{{profileInfo.email.charAt(0)}}</p>
                                    </div>
                                    <div class="profileDetalieHead section_title mb-0">
                                        <h5 class="m-0">
                                            <span class="nameIFt" v-if="profileInfo.firstname">{{profileInfo.firstname}} {{profileInfo.lastname}}</span>
                                            <span class="emailID" v-else>{{profileInfo.email}}</span>
                                        </h5>
                                        <p class="m-0" v-if="parseInt(get_user.tier) == 1">Complete your verification steps.</p>
                                        <p class="m-0" v-else-if="parseInt(get_user.tier) == 2">Your Account is under verification.</p>
                                        <p class="m-0" v-else-if="parseInt(get_user.tier) == 3">Add Bank Account.</p>
                                        <p class="m-0" v-else-if="parseInt(get_user.tier) == 4">Your bank account verification is under process.</p>
                                    </div>
                                </div>
                                <div class="buttonProfile" v-if="parseInt(get_user.tier) < 5">
                                    <!-- <router-link class="cap_btn blue" to="/home">Go to Dashboard</router-link> -->
                                    <a href="#" @click.prevent="withdrawLimit()" class="cap_btn blue" :class="[([2,4].includes(parseInt(get_user.tier)))?'disabled':'', {'disabled': pageLoader }]">Upgrade to {{(parseInt(get_user.tier) <= 2)?'higher limits':'withdraw fiat' }}</a>

                                </div>
                                <!-- <div class="buttonProfile" v-else-if="parseInt(get_user.tier) == 2">
                                    <a href="#" @click.prevent="" class="cap_btn blue disabled">Upgrade to higher limits</a>
                                </div>
                                <div class="buttonProfile" v-else-if="parseInt(get_user.tier) == 3">
                                    <router-link :to="{name: 'support' , params: { 'tabName':'requestServiceElement','page':'profile', 'ticketData' : '16','method_id':'1'}}" @click.prevent="" class="cap_btn blue">Upgrade to higher limits</router-link>
                                </div>
                                <div class="buttonProfile" v-else-if="parseInt(get_user.tier) == 4">
                                    <a href="#" @click.prevent="" class="cap_btn blue disabled">Upgrade to higher limits</a>
                                </div> -->
                            </div>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="newProfileTb d-flex">
                            <div class="inBox d-flex justify-content-between">
                                <div class="depoist_fund profileInfo">
                                    <ul class="nav nav-tabs noBG border-0">
                                        <li class="nav-item">
                                            <a class="nav-link" :class="(tab == '1')?'active':''" @click.prevent="ChangeTab('1')"><feather class="ftsIco" type="info"></feather> Basic Info</a>
                                        </li>
                                        <li class="nav-item"  v-if="parseInt(get_user.lead_type) == 1">
                                            <a class="nav-link" :class="(tab == '2')?'active':''" @click.prevent="ChangeTab('2')"><feather class="ftsIco" type="info"></feather> Organization Info</a>
                                        </li>
                                        <li class="nav-item">
                                            <a class="nav-link" :class="(tab == '3')?'active':''" @click.prevent="ChangeTab('3')"><feather class="ftsIco" type="map-pin"></feather> Address Info</a>
                                        </li>
    									<li class="nav-item">
                                            <a class="nav-link" :class="(tab == '4')?'active':''" @click.prevent="ChangeTab('4')"><feather class="ftsIco" type="file-text"></feather> Documents</a>
                                        </li>
                                        <li class="nav-item">
                                            <a class="nav-link" :class="(tab == '5')?'active':''" @click.prevent="ChangeTab('5')"><feather class="ftsIco" type="credit-card"></feather> Withdrawing Limits </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <!--Tabs here-->
                            <div class="tab-content proRight">
                                <div id="deposit" class="tab-pane active" v-if="tab == '1'">
                                    <edit-number v-if="editNumber"></edit-number>
                                	<!-- Individual Account Detail -->
                                	<div class="accointInforight row d-flex align-items-center" v-else>
                                        <div class="col-md-6 mb-md-2">
                                            <div class="formField">
                                                <strong>First Name</strong>
                                                <span>{{(profileInfo.firstname != null && profileInfo.firstname != '')?profileInfo.firstname:'-'}}</span>
                                            </div>
                                        </div>
                                        <div class="col-md-6 mb-md-2">
                                            <div class="formField">
                                                <strong>Last Name</strong>
                                                <span>{{(profileInfo.lastname != null && profileInfo.lastname != '')?profileInfo.lastname:'-'}}</span>
                                            </div>
                                        </div>
                                        <div class="col-md-6 mb-md-2">
                                            <div class="formField">
                                                <strong>Email Address</strong>
                                                <span>{{(profileInfo.email != null && profileInfo.email != '')?profileInfo.email:'-'}}</span>
                                            </div>
                                        </div>
                                        <div class="col-md-6 mb-md-2">
                                            <div class="formField d-flex align-items-center justify-content-between">
                                                <div class="null-number">
                                                <strong> Phone</strong>
                                                <span>{{(get_user.mobile_no != null && get_user.mobile_no != '')?get_user.mobile_no:'-'}}</span>
                                                </div>
                                                <span class="editInfo editNumber d-flex align-items-center justify-content-center" @click="editNumber = !editNumber" v-if="parseInt(get_user.tier) > 2">
                                                    <feather type="edit"></feather>
                                                </span>
                                                <!-- <span class="editInfo editNumber d-flex align-items-center justify-content-center" @click="withdrawLimit()" v-else-if="parseInt(get_user.tier) == 1">
                                                     <feather type="edit"></feather> 
                                                </span> -->
                                                <!-- <router-link :to="(parseInt(get_user.lead_type) == 0)?'/individual-step'+(parseInt(get_user.step)+1):(parseInt(get_user.lead_type) == 1)?'/corporate-step'+(parseInt(get_user.step)+1):'#'" class="editInfo editNumber d-flex align-items-center justify-content-center" v-else-if="parseInt(get_user.tier) == 1 && ( (parseInt(get_user.lead_type) == 0 && parseInt(get_user.step) < 3) || (parseInt(get_user.lead_type) == 1 && parseInt(get_user.step) < 4) )">
                                                    <feather type="edit"></feather>
                                                </router-link>
                                                <span class="editInfo editNumber d-flex align-items-center justify-content-center" :class="[{'disabled':parseInt(get_user.tier) == 2}]" @click.prevent="withdrawLimit()" v-else>
                                                    <feather type="edit"></feather>
                                                </span> -->
                                            </div>
                                        </div>
                                        <div class="col-md-6 mb-md-2">
                                            <div class="formField">
                                                <strong>Date of birth</strong>
                                                <span>{{profileInfo.dob | moment('Do MMMM YYYY')}}</span>
                                            </div>
                                        </div>
                                        <div class="col-md-6 mb-md-2" v-if="parseInt(get_user.lead_type) == 1" >
                                            <div class="formField">
                                                <strong>Job Title</strong>
                                                <span>{{(profileInfo.job_title != null && profileInfo.job_title != '')?profileInfo.job_title:'-'}}</span>
                                            </div>
                                        </div>
                                	</div>
                                    <!-- <div class="mt-md-5 row justify-content-center">
                                        <div class="col-12">
                                            <div>
                                                <div class="row">
                                                    <div class="col-4">
                                                        <div class="form-group">
                                                            <input type="text" class="form-control" name="first_name" v-model="fname" v-validate="'required'" placeholder=" ">
                                                            <label class="labeltext">First Name</label>
                                                            <span v-show="submitted && errors.has('first_name')" class="text-danger">The first name is required</span>
                                                        </div>
                                                    </div>
                                                    <div class="col-4">
                                                        <div class="form-group">
                                                            <input type="text" class="form-control" name="middle_name" v-model="mName" v-validate="'required'" placeholder=" ">
                                                            <label class="labeltext">Middle Name</label>
                                                            <span v-show="submitted && errors.has('middle_name')" class="text-danger">The middle name is required</span>
                                                        </div>
                                                    </div>
                                                    <div class="col-4">
                                                        <div class="form-group">
                                                            <input type="text" class="form-control" name="last_name" v-model="lname" v-validate="'required'" placeholder=" ">
                                                            <label class="labeltext">Last Name</label>
                                                            <span v-show="submitted && errors.has('last_name')" class="text-danger">The last name is required</span>
                                                        </div>
                                                    </div>
                                                    <div class="col-5">
                                                        <div class="form-group dob">
                                                            <datepicker class="form-control" placeholder="DOB (DD/MM/YYYY)" name="dob" v-model="dob" v-validate="'required'"> </datepicker>

                                                            <span v-show="submitted && errors.has('dob')" class="text-danger">DOB is required</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-10">
                                                        <div class="row">
                                                            <div class="col-12">
                                                                <div class="form-group">
                                                                    <input type="text" class="form-control" name="full_adrs" v-model="address" v-validate="'required'" placeholder=" ">
                                                                    <label class="labeltext">Full address</label>
                                                                    <span v-show="submitted && errors.has('full_adrs')" class="text-danger">The address is required</span>
                                                                </div>
                                                            </div>
                                                            <div class="col-6">
                                                                <div class="form-group">
                                                                    <input type="text" class="form-control" name="city" v-model="city" v-validate="'required'" placeholder=" ">
                                                                    <label class="labeltext">City</label>
                                                                    <span v-show="submitted && errors.has('city')" class="text-danger">The City is required</span>
                                                                </div>
                                                            </div>
                                                            <div class="col-6">
                                                                <div class="form-group">
                                                                    <input type="text" class="form-control" name="state" v-model="state" v-validate="'required'" placeholder=" ">
                                                                    <label class="labeltext">State</label>
                                                                    <span v-show="submitted && errors.has('state')" class="text-danger">The State is required</span>
                                                                </div>
                                                            </div>
                                                            <div class="col-6">
                                                                <div class="form-group">
                                                                    <input type="text" class="form-control" name="country" v-model="country" v-validate="'required'" placeholder=" ">
                                                                    <label class="labeltext">Country</label>
                                                                    <span v-show="submitted && errors.has('country')" class="text-danger">The Country is required</span>
                                                                </div>
                                                            </div>
                                                            <div class="col-6">
                                                                <div class="form-group">
                                                                    <input type="text" class="form-control" name="area_code" v-model="area_code" v-validate="'required'" placeholder=" ">
                                                                    <label class="labeltext">Area Code</label>
                                                                    <span v-show="submitted && errors.has('area_code')" class="text-danger">This is required</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row mt-4">
                                                    <div class="col-7 tp">
                                                        <h4 class="cap_subtitle">Account Type</h4>
                                                    </div>
                                                    <div class="col-5">
                                                        <div class="form-group">
                                                            <select class="form-control" name="acc_type" data-placeholder="Select Account Type" v-model="acc_type" v-validate="'required'" onclick="this.setAttribute('value', this.value);" value="">
                                                                <option value=""></option>
                                                                <option value="ab">Individual</option>
                                                                <option value="ab">Corporate</option>
                                                            </select>
                                                            <label class="labeltext">Select Account</label>
                                                            <span v-show="submitted && errors.has('acc_type')" class="text-danger">Account Type is required</span>
                                                        </div>
                                                    </div>
                                                    <div class="col-12 text-center mt-5">
                                                        <input type="submit" class="cap_btn blue pl-3 pr-3 large_btn" value="Update Now" name="" @click="Submit()">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div> -->
                                </div>
                                <div id="deposit" class="tab-pane active" v-if="tab == '2'">
                                	<div class="accointInforight row d-flex align-items-center">
                                        <div class="col-md-6 mb-md-2">
                                            <div class="formField">
                                                <strong>Organization Legal Name</strong>
                                                <span>{{(profileInfo.legal_name)?profileInfo.legal_name:'-'}}</span>
                                            </div>
                                        </div>
                                        <div class="col-md-6 mb-md-2">
                                            <div class="formField">
                                                <strong>Organization Type</strong>
                                                <span>{{(['0','1','2','3'].includes(profileInfo.org_type))?OrganizationType[profileInfo.org_type]:'-'}}</span>
                                            </div>
                                        </div>
                                        <div class="col-md-6 mb-md-2">
                                            <div class="formField">
                                                <strong>Business Activities & Source of Funds</strong>
                                                <span>{{(profileInfo.src_of_funds)?profileInfo.src_of_funds:'-'}}</span>
                                            </div>
                                        </div>
                                        <div class="col-md-6 mb-md-2">
                                            <div class="formField">
                                                <strong>Organization's Tax ID</strong>
                                                <span>{{(profileInfo.tax_id)?profileInfo.tax_id:'-'}}</span>
                                            </div>
                                        </div>
                                        <div class="col-md-6 mb-md-2">
                                            <div class="formField">
                                                <strong>Business's Registered Office Address</strong>
                                                <span>{{(profileInfo.org_address)?profileInfo.org_address:'-'}}</span>
                                            </div>
                                        </div>
                                        <div class="col-md-6 mb-md-2">
                                            <div class="formField">
                                                <strong>Organization registered country</strong>
                                                <!-- <span>{{(profileInfo.registered_country)?($env_var.countriesList[profileInfo.registered_country]?$env_var.countriesList[profileInfo.registered_country].name:profileInfo.registered_country):'-'}}</span> -->
                                                <span>{{(profileInfo.registered_country)?($env_var.countriesList[profileInfo.registered_country]?$env_var.countriesList[profileInfo.registered_country].name:profileInfo.registered_country):'-'}}</span>
                                            </div>
                                        </div>
                                	</div>
                                </div>
                                <div id="Address" class="tab-pane active" v-if="tab == '3'">
                                    <div class="editField d-flex justify-content-end">
                                        <button class="editInfo btn d-flex align-items-center justify-content-center" @click="editAddress = !editAddress" v-if="parseInt(get_user.tier) > 2"><feather :type="(editAddress)?'x':'edit'"></feather> </button>
                                        <!-- <button class="editInfo btn d-flex align-items-center justify-content-center" @click="withdrawLimit()" v-if="parseInt(get_user.tier) == 1"><feather type="edit"></feather> </button> -->
                                        <!-- <button class="editInfo btn d-flex align-items-center justify-content-center" @click="$router.push({ path: (parseInt(get_user.lead_type) == 0)?'individual-step':'corporate-step'+(parseInt(get_user.step)+1) })" v-else-if="parseInt(get_user.tier) == 1 && ( (parseInt(get_user.lead_type) == 0 && parseInt(get_user.step) < 3) || (parseInt(get_user.lead_type) == 1 && parseInt(get_user.step) < 4) )"><feather type="edit"></feather> </button>
                                        <router-link :to="(parseInt(get_user.lead_type) == 0)?'/individual-step'+(parseInt(get_user.step)+1):(parseInt(get_user.lead_type) == 1)?'/corporate-step'+(parseInt(get_user.step)+1):'#'" class="editInfo btn d-flex align-items-center justify-content-center" v-else-if="parseInt(get_user.tier) == 1 && ( (parseInt(get_user.lead_type) == 0 && parseInt(get_user.step) < 3) || (parseInt(get_user.lead_type) == 1 && parseInt(get_user.step) < 4) )">
                                            <feather type="edit"></feather>
                                        </router-link> -->
                                    </div>
                                    <edit-address v-if="editAddress"></edit-address>
                                    <div class="accointInforight row d-flex align-items-center" v-else>
                                        <div class="col-md-6 mb-md-2">
                                            <div class="formField">
                                                <strong> Residential Address line 1</strong>
                                                <span>{{(profileInfo.address1 != null && profileInfo.address1 != '')?profileInfo.address1:'-'}}</span>
                                            </div>
                                        </div>
                                        <div class="col-md-6 mb-md-2">
                                            <div class="formField">
                                                <strong> Residential Address line 2</strong>
                                                <span>{{(profileInfo.address2 != null && profileInfo.address2 != '')?profileInfo.address2:'-'}}</span>
                                            </div>
                                        </div>
                                        <div class="col-md-6 mb-md-2">
                                            <div class="formField">
                                                <strong> Post Code</strong>
                                                <span>{{(profileInfo.post_code)?profileInfo.post_code:(profileInfo.zip_code)?profileInfo.zip_code:'-'}}</span>
                                            </div>
                                        </div>
                                        <div class="col-md-6 mb-md-2">
                                            <div class="formField">
                                                <strong> City or Town</strong>
                                                <span>{{(profileInfo.city != null && profileInfo.city != '')?profileInfo.city:'-'}}</span>
                                            </div>
                                        </div>
                                        <div class="col-md-6 mb-md-2">
                                            <div class="formField">
                                                <strong> Nationality</strong>
                                                <span>{{(profileInfo.nationality)?($env_var.countriesList[profileInfo.nationality]?$env_var.countriesList[profileInfo.nationality].name:profileInfo.nationality):'-'}}</span>
                                            </div>
                                        </div>
                                        <div class="col-md-6 mb-md-2">
                                            <div class="formField">
                                                <strong> Residence Country</strong>
                                                <span>{{(profileInfo.residence_country)?($env_var.countriesList[profileInfo.residence_country]?$env_var.countriesList[profileInfo.residence_country].name:profileInfo.residence_country):'-'}}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
    							<div id="documents" class="tab-pane active" v-if="tab == '4'">
                                    <div class="main_outer_tblsec d-flex flex-wrap justify-content-between documentAddInfo  clearfix">
        								<p class="information_it" v-for="item in profileInfo.documents">
        									<a class="UploadedProof" :href="$env_var.docsLink+'user&id='+get_user.profile.user_id+'&doc='+item.document" target="_blank()" >
                                                <div class="d-flex dicAdd align-items-center">  
            										<span class="uploadclipIcons"><img :src="$env_var.docsLink+'user&id='+get_user.profile.user_id+'&doc='+item.document" /></span>
                                                    <small>{{item.document_name}}</small>
                                                </div>
                                                <span class="nexttopic"><!--  @click.prevent.stop="create_image($env_var.docsLink+'user&id='+get_user.profile.user_id+'&doc='+item.document,item.document)" -->
                                                    <span><feather type="eye"></feather></span>
                                                </span>
        									</a>
        								</p>
                                        <div class="dataTables_empty mx-auto w-100" v-if="profileInfo.documents.length < 1">
                                                <span class="noData-img my-3">
                                                <img src="../../../../static/website/images/no-data.png" alt="Icon">    
                                                </span>
                                                <span>No document found</span>
                                            </div>
                                    </div>
                                    <!--Static Documents-->
                                    <!-- <div class="main_outer_tblsec documentAddInfo  mt-3 clearfix">
                                        <p>
                                            <a href="#">
                                                <div class="d-flex dicAdd align-items-center">
                                                    <span><feather type="paperclip"></feather></span>
                                                    <span class="uploadclipIcons">
                                                        <b>Govt Document</b>
                                                    </span> 
                                                    <small>413kb</small>
                                                </div> 
                                                <span class="nexttopic">
                                                    <span><feather type="download"></feather></span>
                                                </span>
                                            </a>
                                        </p>
                                        <p>
                                            <a href="#">
                                                <div class="d-flex dicAdd align-items-center">
                                                    <span><feather type="paperclip"></feather></span>
                                                    <span class="uploadclipIcons">
                                                        <b>Govt Document</b>
                                                    </span> 
                                                    <small>413kb</small>
                                                </div> 
                                                <span class="nexttopic">
                                                    <span><feather type="download"></feather></span>
                                                </span>
                                            </a>
                                        </p>
                                        <p>
                                            <a href="#">
                                                <div class="d-flex dicAdd align-items-center">
                                                    <span><feather type="paperclip"></feather></span>
                                                    <span class="uploadclipIcons">
                                                        <b>Govt Document</b>
                                                    </span> 
                                                    <small>413kb</small>
                                                </div> 
                                                <span class="nexttopic">
                                                    <span><feather type="download"></feather></span>
                                                </span>
                                            </a>
                                        </p>
                                    </div> -->
    								<!--End Static-->
    							</div>
                                <div id="withdraw" class="tab-pane active" v-if="tab == '5'">
                                    <div class="btC d-flex align-items-center justify-content-between">
                                        <div class="hightLimit">
                                        <p class="cur_result" v-if="parseInt(get_user.tier) <= 2">Tier 1 Verification</p>
                                        <p class="cur_result" v-else-if="parseInt(get_user.tier) <=4">Tier 2 Verification</p>
                                        <p class="cur_result" v-else>Tier 3 Verification</p>
                                        <ul class="m-0">
                                            <li v-if="parseInt(get_user.tier) <= 2">Deposit Upto 1 BTC (Lifetime)</li>
                                            <li v-else-if="parseInt(get_user.tier) <=4">Withdraw Upto 100 BTC (daily) </li>
                                            <li v-else>Pro Limits Apply</li>
                                        </ul>
                                        </div>
										
										
                                        <router-link :to="'/individual-step'+(parseInt(get_user.step)+1)" class="cap_btn blue" v-if="parseInt(get_user.lead_type) == 0 && parseInt(get_user.step) < 3">Upgrade to higher limits</router-link>
                                        <router-link :to="'/corporate-step'+(parseInt(get_user.step)+1)" class="cap_btn blue" v-if="parseInt(get_user.lead_type) == 1 && parseInt(get_user.step) < 4">Upgrade to higher limits</router-link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</div>
</template>

<script>
import { registerStepsMixins } from '@/plugins/registerSteps'
import editAddress from './edit_Address'
import editNumber from './edit_Number'
export default {
    name: 'accountprofile',
    mixins: [registerStepsMixins],
    data() {
        return {
            pageLoader: false,
            notification_msg:'',
            notification_type:'',
            tab: '1',
            submitted: false,
            editAddress: false,
            editNumber: false,

            fname: '',
            mName: '',
            lname: '',
            dob: '',
            address: '',
            city: '',
            state: '',
            country: '',
            area_code: '',
            acc_type: '',
            OrganizationType:{
            	'0':'Company',
            	'1':'Self Managed Super Fund',
            	'2':'Discretionary/Unit Trust',
            	'3':'Others'
            }
        }
    },
    components:{
        editAddress,
        editNumber 
    },

    methods: {
        create_image(url,name){
            var stx = this.stxx
            var link = document.createElement('a');
            link.download = name;
            link.href = url
            link.click();
        },
        ChangeTab(val){
            this.tab = val
            this.editAddress = false
            this.editNumber = false
            this.pageLoader = false
        },
        Submit() {
            const _that = this
            _that.submitted = true;
            _that.$validator.validate().then(valid => {
                if (valid) {
                    let input_json = {
                        'globalParams': {
                            'f_name': _that.fname,
                            'm_name': _that.mName,
                            'l_name': _that.lname,
                            'dob': _that.dob,
                            'Address': _that.address,
                            'City': _that.city,
                            'State': _that.state,
                            'Country': _that.country,
                            'Areacode': _that.area_code,
                            'Acc_type': _that.acc_type,
                        },
                        localParams: {
                            "parameter": _that
                        }
                    }

                }
            });
        }
    },
    created() {
        this.pageName('Account Profile')
        this._runGetProfileInfo({
            globalParams: {
				
			},
            localParams: {
                "parameter": this
            }
        })
    }
}
</script>



// WEBPACK FOOTER //
// src/components/website/account/accountprofile.vue